// extracted by mini-css-extract-plugin
export default {"container":"J5H1-wufLCuar_wW5tjd-","noProjectText":"_2aPz8BQ3DnBjE7UuzFOlUT"};